// @flow

import _ from 'lodash';
import gql from 'graphql-tag';
import { connect } from 'react-redux';

import { graphql } from '@apollo/react-hoc'; // eslint-disable-line no-restricted-syntax

import SplitLoginPage from 'app/login/components/SplitLoginPage';
import maybeRender from 'app/common/components/maybeRender';
import { selectNextRouteMatchWithZapTemplateId } from 'app/login/Selectors';

const zapTemplateQuery = gql`
  query ZtSplitLoginPageContainerQuery($id: ID!) {
    zapTemplateById(id: $id) {
      title
      steps
      headService {
        id
        name
      }
      tailService {
        id
        name
      }
      services {
        id
        name
      }
    }
  }
`;

export default _.flowRight(
  graphql(zapTemplateQuery, {
    options: props => {
      const ztId = selectNextRouteMatchWithZapTemplateId(null, props);

      return {
        variables: {
          id: ztId,
        },
      };
    },
  }),
  connect(),
  maybeRender(props => !props.data.loading)
)(SplitLoginPage);
